import _ from 'lodash';
import {getBookmarkAPI, updateBookmarkAPI} from '../../../service/bookmarkService';
import Constant from "@/common/constant/Constant";
import Utils from "@/common/utils/utils";
import { createKibanaEditContentOperation } from '@/component/system/logKibanaHandler/LogKibanaHandler';

const getAllBookmarkInProjectInuse = async (userId, projectInuseId, targetType) => {
    if (!userId || !projectInuseId) return;

    let getBookmarkListParams = {
        actionType: Constant.BOOKMARK_GET_API_ACTION.GET_ALL_BOOKMARK_USER_CAN_USE,
        projectInuse: projectInuseId,
        userId: userId,
        targetType: targetType
    };

    let response = await getBookmarkAPI(getBookmarkListParams);
    return Utils.convertJSONDataToObject(response.data);
}

const handleSubmitEditBookmark = async(
    submitData,
    listBookmarkCompare,
    corporationDetail,
    projectInuseDetail,
    userDetail,
    ticketDetail,
    setIsLoadingBookmark,
    setIsOpenModalReloadPage,
    funcTriggerDetailTicket,
    reloadTicketListByPanelType
) => {
    document.body.style.cursor='wait';
    setIsLoadingBookmark(true)
    const corporationId = corporationDetail?.id;
    const projectInuseId = projectInuseDetail?.id;
    const userId = userDetail?.id;
    const ticketId = ticketDetail?.id;
    let addData= [...submitData.addNew]
    let editData= [...submitData.edit]

    let compare = [];
    let bookmarkIncludeTicketNotChangeIdList = listBookmarkCompare.filter(b => b.isTagged).map(b => b.id)

    for (const initEditData of listBookmarkCompare) {
        for (const edited of editData) {
            if (initEditData.id === edited.id && !_.isEqual(initEditData, edited)) {
                compare.push(edited);
            }
        }
    }
    bookmarkIncludeTicketNotChangeIdList = bookmarkIncludeTicketNotChangeIdList.filter(id => !compare.some(b => (b.id === id && !b.isTagged)))
    
    const dataLog = {
        corporationDetail: corporationDetail,
        projectDetail: projectInuseDetail,
        userDetail: userDetail,
        ticketDetail: ticketDetail,
        formDetail: {},
        publicRange: ''
    };
    const logKibanaData = createKibanaEditContentOperation(dataLog);

    let submitParams = {
        action: Constant.BOOKMARK_UPDATE_API_ACTION.ADD_AND_UPDATE_MULTI_BOOKMARK,
        corporationInuse: corporationId,
        projectInuse: projectInuseId,
        userId: userId,
        ticketId: ticketId,
        data: JSON.stringify({
            addNew: addData,
            edit: compare.map(b => {
                if (b.definition === Constant.BOOKMARK_DEFINITION.SYSTEM && Utils.isEmptyString(b.defaultBookmark)) {
                    return {...b, defaultBookmark: Constant.NA}
                }
                return b
            }),
            bookmarkIncludeTicketNotChangeIdList: bookmarkIncludeTicketNotChangeIdList,
            logInfo: logKibanaData
        })
    };
    let addResponse = await updateBookmarkAPI(submitParams);

    if (!addResponse.status) {
        document.body.style.cursor='default';
        setIsOpenModalReloadPage({
            isOpen: true,
            errorCode: addResponse.errorCode
        });

        return;
    }

    await Utils.delay(1000);

    funcTriggerDetailTicket(ticketId);

    const bookmarkTargetType = Utils.getBookmarkTargetTypeByTicketType(ticketDetail.ticketType);
    if (bookmarkTargetType === Constant.BOOKMARK_TARGET_TYPE.KNOWLEDGE) {
        reloadTicketListByPanelType({panelType: Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST});
    }
    if (bookmarkTargetType === Constant.BOOKMARK_TARGET_TYPE.TICKET) {
        reloadTicketListByPanelType({panelType: Constant.PANEL_TYPE.HELPDESK_TICKET_LIST})
    }

    document.body.style.cursor='default';
    setIsLoadingBookmark(false)
}

export {
    getAllBookmarkInProjectInuse,
    handleSubmitEditBookmark,
}